import { render, staticRenderFns } from "./ChildAvatar.vue?vue&type=template&id=eaccfa2c&scoped=true&"
import script from "./ChildAvatar.vue?vue&type=script&lang=js&"
export * from "./ChildAvatar.vue?vue&type=script&lang=js&"
import style0 from "./ChildAvatar.vue?vue&type=style&index=0&id=eaccfa2c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eaccfa2c",
  null
  
)

export default component.exports